import { render, staticRenderFns } from "./corporateAssets.vue?vue&type=template&id=742b3605"
import script from "./corporateAssets.vue?vue&type=script&lang=js"
export * from "./corporateAssets.vue?vue&type=script&lang=js"
import style0 from "./corporateAssets.vue?vue&type=style&index=0&id=742b3605&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports